import InfoCard from "../../../../components/InfoCard/skeleton";

function BoletoCard() {
  return <InfoCard />;
}

export default BoletoCard;
